// default
export const EXCEL = 'excel';
export const EXCEL_SLICE_NAME = `${EXCEL}Slice`;

// action
const EXCEL_ENROLL = `${EXCEL}/enroll`;
const EXCEL_DOWNLOAD_TEMPLATE = `${EXCEL}/downloadTemplate`;
const EXCEL_DOWNLOAD_LIST = `${EXCEL}/downloadList`;

// actions
export const actions = {
  EXCEL_ENROLL,
  EXCEL_DOWNLOAD_TEMPLATE,
  EXCEL_DOWNLOAD_LIST
};
